import {
  DeploymentFactsError,
  GATE_ROUTES,
  gatePath,
  parseDeploymentFacts,
  type DeploymentFacts,
} from "@karvstokk/config/client";

/**
 * What the SPA asks at startup instead of having it baked into the bundle
 * (#158): one bundle serves both environments, so which chain and which RP ID
 * are answers from the deployment, not constants of the build.
 *
 * Same origin by construction (#47), so the path is relative and there is no
 * host here to get wrong.
 */
const DEPLOYMENT_FACTS_PATH = gatePath(GATE_ROUTES.deployment);

/** The one fetch this module needs — a seam for the tests, not an option. */
type FetchLike = (input: string) => Promise<Response>;

/**
 * Fetch and check the deployment's facts, or throw.
 *
 * The check is config's `parseDeploymentFacts`, beside the gate's
 * `deploymentFactsOf` that encodes them, so the two ends of the wire are
 * pinned by one test (#183). It fails closed: an answer the SPA cannot fully
 * trust renders no onboarding, because the RP ID in it is permanent for every
 * credential registered under it (ADR-0010 decision 2).
 */
export async function readDeploymentFacts(
  fetch: FetchLike,
): Promise<DeploymentFacts> {
  const res = await fetch(DEPLOYMENT_FACTS_PATH);
  if (res.status !== 200) {
    throw new DeploymentFactsError(
      `${DEPLOYMENT_FACTS_PATH} answered ${res.status}`,
    );
  }
  return parseDeploymentFacts(await res.json());
}
